import DynamicOffer from 'application/src/js/market/trade-items/dynamic-offer.js';
export default DynamicOffer;